import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MainComponent } from "../main/main.component";

@Component({
  selector: 'app-main-admin',
  imports: [MainComponent],
  templateUrl: './main-admin.component.html',
  styleUrl: './main-admin.component.scss'
})
export class MainAdminComponent {

    model!: MenuItem[]

    ngOnInit() {
        localStorage.removeItem("electionName")
        const userRole = localStorage.getItem('roles');
        if (userRole?.includes("ROLE_SYS_ADMIN")) {
          this.model = [
              {
                  label: 'Home',
                  items: [{ label: 'Home', icon: 'pi pi-fw pi-home', routerLink: ['/'] }
                      ]
              }
            ]
        } else if (userRole?.includes("ROLE_ADMIN")) {
          this.model = [
              {
                  label: 'Home',
                  items: [{ label: 'Home', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
                      ]
              }
            ]
        } else if (userRole?.includes("ROLE_USER")) {
          this.model = [
              {
                  label: 'Home',
                  items: [{ label: 'Home', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
                        ]
              }
            ]
        }
      }
}
